import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

// 保存用户openid
const openidKey = 'openid'
export function getOpenId () {
  return Cookies.get(openidKey)
}
export function setOpenId (openid) {
  return Cookies.set(openidKey, openid)
}
export function removeOpenId (openid) {
  return Cookies.remove(openidKey, openid)
}
